
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9999 12.6585C14.6671 12.6585 16.8292 10.4964 16.8292 7.82927C16.8292 5.16214 14.6671 3 11.9999 3C9.33279 3 7.17065 5.16214 7.17065 7.82927C7.17065 10.4964 9.33279 12.6585 11.9999 12.6585ZM12 18C12 16.8556 12.3204 15.786 12.8764 14.876C12.5851 14.8614 12.2926 14.8536 12 14.8536C9.72934 14.8536 7.4587 15.3234 5.79568 15.7773C4.27051 16.1927 3.21948 17.5826 3.21948 19.1631V21H12.8027C12.2922 20.1175 12 19.0929 12 18ZM17.75 16.0503C17.75 15.3321 18.3321 14.75 19.0503 14.75C20.2087 14.75 20.7888 16.1506 19.9697 16.9697L16.4697 20.4697C16.2552 20.6842 16.191 21.0068 16.3071 21.287C16.4232 21.5673 16.6967 21.75 17 21.75H22V20.25H18.8107L21.0303 18.0303C22.7944 16.2663 21.545 13.25 19.0503 13.25C17.5037 13.25 16.25 14.5037 16.25 16.0503V17H17.75V16.0503Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowSecondaryLoginFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
